import React, { useState } from "react"
import styles from "./WindowItem.module.css"
import ProductItem from "../ProductItem/ProductItem"
import { FiPlus, FiX, FiChevronDown, FiChevronRight } from "react-icons/fi"

const WindowItem = ({
    window,
    getProductImage,
}) => {
    const [isExpanded, setIsExpanded] = useState(true) // Default expanded

    const toggleExpand = () => {
        setIsExpanded(!isExpanded)
    }

    return (
        <>
            <div className={`w-100 ${styles.windowCard}`}>
                {/* Window Header - Always visible */}
                <div className={styles.windowHeader}>
                    <div className={styles.windowInfo}>
                        <button
                            className={styles.expandButton}
                            onClick={toggleExpand}
                            title={isExpanded ? "Collapse" : "Expand"}
                        >
                            {isExpanded ? (
                                <FiChevronDown size={16} />
                            ) : (
                                <FiChevronRight size={16} />
                            )}
                        </button>
                        <span className={styles.windowName}>Window: {window.name}</span>
                    </div>
                </div>

                {/* Window Products - Only shown when expanded */}
                {isExpanded && (
                    <>
                        {window.products && window.products.length > 0 ? (
                            <div className={styles.windowProductsList}>
                                {window.products.map((product, productIndex) => {
                                    const productData = product.selection_id?.product_id
                                    const userSelection = product.selection_id?.userSelection
                                    const imageUrl = getProductImage(product)

                                    return (
                                        <ProductItem
                                            key={productIndex}
                                            product={product}
                                            productData={productData}
                                            userSelection={userSelection}
                                            imageUrl={imageUrl}
                                        />
                                    )
                                })}
                            </div>
                        ) : null}
                    </>
                )}
            </div>
        </>
    )
}

export default WindowItem
